export default __webpack_public_path__ + "static/media/callejeritos_isotipo.188396e3.png";